import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  padding-block: 16px;
  padding-inline: 0;
`;

export const PlaceholderBar = styled.div<{ $height: number; $width: string }>`
  inline-size: ${props => props.$width};
  block-size: ${props => props.$height}px;

  border-radius: 4px;

  background: #e5e5e5;

  animation: pulse 1.5s ease-in-out infinite;

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
`;
